@if (show) {
    <div class="t5">
        <div class="c-secondary-red-800">
            {{ 'i18n_af_errorPasswordPatternPart1' | translate }}
            <a class="error-link-underline" (click)="expanded = !expanded">
                {{ 'i18n_af_errorPasswordPatternPart2' | translate }}
            </a>
        </div>
        @if (expanded) {
            <ul class="mt-4 pl-16">
                <li [class.c-secondary-red-800]="!checks.length" [class.c-primary-green-800]="checks.length">
                    {{ 'i18n_af_passwordRuleLength' | translate }}
                </li>
                <li [class.c-secondary-red-800]="!checks.charset" [class.c-primary-green-800]="checks.charset">
                    {{ 'i18n_af_passwordRecoveryRuleLatin' | translate }}
                </li>
                <li [class.c-secondary-red-800]="!checks.case" [class.c-primary-green-800]="checks.case">
                    {{ 'i18n_af_passwordRuleCase' | translate }}
                </li>
                <li [class.c-secondary-red-800]="!checks.digit" [class.c-primary-green-800]="checks.digit">
                    {{ 'i18n_af_passwordRecoveryRuleDigit' | translate }}
                </li>
                <li [class.c-secondary-red-800]="!checks.special" [class.c-primary-green-800]="checks.special">
                    {{ 'i18n_af_passwordRuleSpecial' | translate }}
                </li>
            </ul>
        }
    </div>
}
